 import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import {ReducerType} from "../reducer.type";
import actions from "./actions";
import { getCustomerAttributesApi } from "../../services/attributes.service"
import { AxiosResponse } from 'axios';
import { ClientWorkspace } from '../client/client.type';
import logError from "../../utils/logError";
const getWorkspace = (state: ReducerType) => state.client.owner.workspace;

export function* GET_ATTRIBUTES(action: {payload: string, type: string}) {
    const items: ClientWorkspace = yield select(getWorkspace);
    let clientId = action.payload;
    try {
        const response: AxiosResponse<any> = yield call(
          getCustomerAttributesApi,
          items.uuid,
          clientId
        );
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/attributes/sagas/GET_ATTRIBUTES", e); }
}

export default function* rootSaga() {
yield all([
    takeEvery(actions.GET_DATA, GET_ATTRIBUTES)
])
 }